import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import CarrierGuardBidDetailsService from '../services/CarrierGuardBidDetailsService';

export const CARRIER_GUARD_BID_DETAILS_QUERY_KEY = '3rd-party-management-fetch-carrier-guard-bid-details';

const useCarrierGuardBidDetails = ({
    freightId,
    bidId,
    t,
}) => {
    return useQuery({
        queryKey: [CARRIER_GUARD_BID_DETAILS_QUERY_KEY, freightId, bidId],
        queryFn: async () => {
            const service = CarrierGuardBidDetailsService.getInstance();

            return await service.fetchDetails(freightId, bidId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!freightId && !!bidId,
        onError: () => {
            toast(t('An error occurred while fetching bid details.'), {
                type: 'error',
            });
        },
    });
};

export default useCarrierGuardBidDetails;
